import { ChangeEvent, useEffect, useState } from 'react';
import { Box } from '@/components/Box/Box';
import OnboardingGuideIcon from '../images/OnboardingGuideIcon.svg?react';
import { SwitchToggle } from '@/components/form/fields/SwitchToggle/SwitchToggle';
import { COLORS } from '@/styles/colors';
import { Typography } from '@/components/Typography/Typography';
import { ONBOARDING_GUIDE_FINISHED_STORAGE_KEY } from '../const';
import { localStorageService } from '@/helpers/storageHelpers';
import { useOnboardingGuide } from '../onboardingGuideContext';
import { useNavigate } from 'react-router';
import { getTransactionsPath } from '@/bundle/_OrgAdmin/path/path';

export const OnboardingGuideToggle = () => {
  const navigate = useNavigate();
  const { isFinished, resetGuide, finishGuide } = useOnboardingGuide();
  const [toggleChecked, setToggleChecked] = useState(() => {
    return !localStorageService.get(ONBOARDING_GUIDE_FINISHED_STORAGE_KEY);
  });

  const toggleOnboardingGuide = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;

    setToggleChecked(checked);

    if (checked) {
      resetGuide();
      navigate(getTransactionsPath());
    } else {
      finishGuide();
    }
  };

  useEffect(() => {
    setToggleChecked(!isFinished);
  }, [isFinished]);

  return (
    <Box display='flex' justifyContent='center' alignItems='center' padding='16px 20px 20px 32px'>
      <Box marginRight='12px'>
        <OnboardingGuideIcon />
      </Box>
      <SwitchToggle
        name='onboarding-guide'
        size='medium'
        hasErrorComponent={false}
        checked={toggleChecked}
        onChange={toggleOnboardingGuide}
        label={
          <Typography color={COLORS.grey[600]} variant='bodySmall'>
            User guide
          </Typography>
        }
      ></SwitchToggle>
    </Box>
  );
};
